<template>
  <div class="sso-callback-wrapper">
    <p>Entrando...</p>
  </div>
</template>

<script>
export default {
  mounted() {
    // O SSO devolve o token no fragment (#token=...), nunca em query string,
    // pra não vazar em log de servidor.
    const hash = window.location.hash || "";
    const token = hash.startsWith("#token=")
      ? decodeURIComponent(hash.slice("#token=".length))
      : null;

    if (!token) {
      this.$router.push("/login");
      return;
    }

    // Login novo: começa do zero (sessão/nó de um usuário anterior no mesmo
    // navegador não deve vazar pro próximo login) — mesmo comportamento do
    // login local (Login.vue).
    localStorage.clear();
    this.$store.commit("auth", token);

    axios
      .post(this.$store.state.api + "me", {})
      .then((response) => {
        if (response.data.access_nivel == 20) {
          this.$router.push({ path: "/condutor/index" });
        } else {
          this.$router.push({ path: "/select-node" });
        }
      })
      .catch(() => {
        this.$router.push({ path: "/select-node" });
      });
  },
};
</script>

<style scoped>
.sso-callback-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}
</style>
